<template>
  <div class="article-content-meta col-3">
    <button
      class="btn sc-btn sc-btn-outline info mb-3"
      :class="{ error: errors.has('coverKey') }"
      @click="showDialog = 'upload'"
    >
      <input
        type="hidden"
        name="coverKey"
        v-model="cover.key"
        v-validate="'required'"
      />
      <img
        src="/static/icons/button-add-cover.svg"
        class="sc-btn-icon"
        width="22"
        height="22"
      />
      <span v-if="!cover.url">{{ $t("button.upload") }}</span>
      <span v-else>{{ canUpdateContent ? "แก้ไข" : "" }}รูปปก</span>
    </button>
    <button
      class="btn sc-btn sc-btn-outline info"
      :class="{ error: errors.has('thumbnailKey') }"
      @click="handleClickUploadThumbnailButton"
    >
      <input type="hidden" name="thumbnailKey" v-model="thumbnail.key" />
      <img
        src="/static/icons/button-add-cover.svg"
        class="sc-btn-icon"
        width="22"
        height="22"
      />
      <span v-if="!this.$isCallCenter && !thumbnail.url"
        >อัปโหลดรูป Thumbnail</span
      >
      <span v-else>{{ canUpdateContent ? "แก้ไข" : "" }}รูป Thumbnail</span>
    </button>
    <div class="setting-options" v-if="settings">
      <ul class="meta-list">
        <li
          class="meta-item text-truncate"
          :class="{ edit: settings.file.name }"
          @click="showDialog = 'setting.file'"
        >
          <h4>{{ $t("feature.article.setting.file") }}</h4>
          <strong>
            {{ settings.file.name }}
          </strong>
        </li>
        <!-- ซ่อน feature แผนที่เนื่องจาก google qouta -->
        <!--li
          class="meta-item text-truncate"
          :class="isDisabledClass(settings.map.locationName)"
          @click="showDialog = 'setting.map'"
        >
          <h4>{{ $t("feature.article.setting.map") }}</h4>
          <strong>
            {{ settings.map.locationName }}
          </strong>
        </li-->
        <li
          class="meta-item text-truncate"
          :class="isDisabledClass(settings.album.length > 0)"
          @click="showDialog = 'setting.album'"
        >
          <h4>{{ $t("feature.article.setting.album") }}</h4>
          <strong v-show="settings.album.length > 0">
            จำนวน {{ settings.album.length }} รูป
          </strong>
        </li>
      </ul>
    </div>
    <setting
      v-if="getSettingOptionAtPosition(0) === 'setting'"
      @isshow="isShow"
      @setEdit="setEdit()"
      :approvedAt="articleApprovedAt"
      :dataSetting="settings"
      :createWithTab="getSettingOptionAtPosition(1)"
      :canEdit="canUpdateContent"
    ></setting>
    <upload
      v-if="showDialog === 'upload'"
      @isshow="isShow"
      @save="saveCover"
      @setEdit="setEdit()"
      :coverUrl="cover.url"
      :coverKey="cover.key"
      :canEdit="true"
    ></upload>
    <upload-thumbnail
      :isShow="uploadThumbnailDialog.isShow"
      :isLoading="uploadThumbnailDialog.isLoading"
      @cancel="handleCancelUploadThumbnailDialog"
      @confirm="handleConfirmUploadThumbnailDialog"
      :thumbnailFile="thumbnail.file"
      :thumbnailUrl="thumbnail.url"
      :thumbnailKey="thumbnail.key"
      :canEdit="true"
    ></upload-thumbnail>
  </div>
</template>

<script>
import axios from "axios";
import Setting from "@/components/admin/view/article/create/Setting";
import Upload from "@/components/helper/dialog/UploadCover";
import UploadThumbnail from "@/components/helper/dialog/UploadThumbnail";

export default {
  props: [
    "dataSettings",
    "articleApprovedAt",
    "cover",
    "canUpdateContent",
    "thumbnail",
    "isThaiLanguage"
  ],
  components: {
    Setting,
    Upload,
    UploadThumbnail
  },
  data() {
    return {
      showDialog: false,
      isEdit: false,
      uploadThumbnailDialog: {
        isShow: false,
        isLoading: false
      }
    };
  },
  computed: {
    settings() {
      return this.dataSettings;
    }
  },
  methods: {
    getSettingOptionAtPosition(position) {
      if (this.showDialog) {
        const value = this.showDialog.split(".", 2);
        return value[position];
      }

      return false;
    },
    isShow() {
      this.showDialog = false;
    },
    saveCover(imgShow, img, imgKey) {
      if (!imgKey || this.cover.key !== imgKey) {
        const vm = this;
        axios
          .get(`${process.env.HOST}/api/uploads/image`, {
            params: {
              imageType: img.type,
              imageName: `articlecover${Date.now()}`,
              featureName: "article"
            }
          })
          .then(res => {
            axios.put(res.data.url, img, {
              headers: { "content-type": img.type }
            });

            vm.$emit("cover", {
              file: img,
              key: res.data.imageKey,
              url: imgShow
            });
          })
          .catch(e => {
            throw e.message;
          });
      }
    },
    setEdit() {
      this.$emit("edited", this.settings);
    },
    async validate() {
      const result = await this.$validator.validate();
      this.$emit("validate", result);
      return result;
    },
    handleClickUploadThumbnailButton() {
      this.uploadThumbnailDialog.isShow = true;
    },
    handleCancelUploadThumbnailDialog() {
      this.uploadThumbnailDialog.isShow = false;
    },
    handleConfirmUploadThumbnailDialog(file) {
      this.uploadThumbnailDialog.isShow = false;

      if (!file) {
        return;
      }

      this.$emit("changeThumbnail", file);
    },
    isDisabledClass(editValue) {
      const disableClass = editValue
        ? {
            "disable-content": !this.isThaiLanguage,
            "edit": editValue
          }
        : {
            "disable-content": !this.isThaiLanguage
          };

      return disableClass;
    }
  }
};
</script>

<style lang="scss" scoped>
.disable-content {
  pointer-events: none;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/article/create/ContentMeta.vue